import { shouldBlockScheduleSelectionDialogClose } from "./should-block-schedule-selection-dialog-close.function";

/**
 * Dialog onClose handler that ignores backdrop/Escape while series time-edit UI is open.
 */
export function createScheduleSelectionDialogCloseHandler(
  blockCloseForTimeEdit: boolean,
  handleClose: () => void
): (_event: object, reason: "backdropClick" | "escapeKeyDown") => void {
  return (_event, reason) => {
    if (shouldBlockScheduleSelectionDialogClose(blockCloseForTimeEdit, reason)) {
      return;
    }
    handleClose();
  };
}
